import * as React from 'react'

import { Box, Tag } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type { FieldType } from 'modules/reports/components/Editor/Field/types'
import type { ReportEditorStore } from 'modules/reports/lib/Store'
import FilterForm from 'modules/reports/lib/Store/FormCollections/Filter/Form'
import type Field from 'modules/reports/store/models/Field'

import FilterGroup from './FilterGroup'

interface Props {
  store: ReportEditorStore
}

const FiltersSelector = (props: Props) => {
  const {
    store,
    store: {
      filters,
      filters: { forms },
      variables,
    },
  } = props

  const [emptyForm, setEmptyForm] = React.useState(() => {
    const emptyForm = new FilterForm()
    emptyForm.buildConditions()
    return emptyForm
  })

  const onReorderFields = (fields: FieldType[]) => {
    store.projection.reorderFields(fields)
  }

  return (
    <>
      {forms.concat(emptyForm).map((filterForm, index) => {
        const handleSelectFields = (fields: Field[]) => {
          filterForm.conditions?.addFiltersFields(fields)

          // If last filter is touched we add an additional block to add more
          // filters so you can perform an OR condition doing so.
          if (index === forms.length) {
            filters.addForm(emptyForm)

            const newEmptyForm = new FilterForm()
            newEmptyForm.buildConditions()
            setEmptyForm(newEmptyForm)
          }
        }

        return (
          <React.Fragment key={index}>
            {index > 0 && (
              <Box justifyContent="center" alignItems="center" padding="s16">
                <Tag type="grey">{i18n.t('custom_reports.logical_operators.or')}</Tag>
              </Box>
            )}
            <FilterGroup
              disabled={!store.isFiltersFieldEnabled()}
              filterForm={filterForm}
              variables={variables}
              onSelectFields={handleSelectFields}
              onRemoveField={(fieldType) => {
                filterForm.conditions?.removeField(fieldType)
              }}
              onReorderFields={onReorderFields}
            />
          </React.Fragment>
        )
      })}
    </>
  )
}

export default observer(FiltersSelector)
